import PropTypes from 'prop-types';
import React from 'react';
import { Controller } from 'react-hook-form';

import YearInput from 'components/atomic/controls/YearInput';

const YearField = ({ name, control, rules = {}, feedback, ...restProps }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        // eslint-disable-next-line no-unused-vars
        field: { ref, ...restField },
        fieldState: { error },
        formState: { isSubmitted },
      }) => (
        <YearInput
          {...restProps}
          {...restField}
          valid={isSubmitted && !error}
          invalid={isSubmitted && error}
          feedback={error?.message || feedback}
        />
      )}
    />
  );
};

YearField.propTypes = {
  name: PropTypes.string,
  control: PropTypes.object,
  rules: PropTypes.object,
  feedback: PropTypes.node,
};

export default YearField;
